import { IdentityTrackingService } from './IdentityTrackingService';
import { PageTrackingService } from './PageTrackingService';
import { EventTrackingService } from './EventTrackingService';

export const eventTracking = new EventTrackingService();
export const identityTracking = new IdentityTrackingService();
export const pageTracking = new PageTrackingService();
